import(/* webpackMode: "eager" */ "/app/apps/web/src/app/[locale]/(public-with-specific-layout)/workfair-register-your-interest/page.tsx")